// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"d6d30507","26":"7072fbf5","239":"8842cf4e","440":"3eebe6c1","488":"016c1889","645":"24eed6a0","806":"606f6b37"}[chunkId] + ".chunk.js";
};